import request from '@/utils/request'


// 查询运费模板列表
export function listShippingTemplate(query) {
  return request({
    url: '/shipping/template/list',
    method: 'post',
    data: query
  })
}

// 查询运费模板分页
export function pageShippingTemplate(query) {
  return request({
    url: '/shipping/template/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

export function selectShippingTemplate(query) {
  return request({
    url: '/shipping/template/select/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询运费模板详细
export function getShippingTemplate(data) {
  return request({
    url: '/shipping/template/detail',
    method: 'get',
    params: data
  })
}

// 新增运费模板
export function addShippingTemplate(data) {
  return request({
    url: '/shipping/template/add',
    method: 'post',
    data: data
  })
}

// 修改运费模板
export function updateShippingTemplate(data) {
  return request({
    url: '/shipping/template/edit',
    method: 'post',
    data: data
  })
}

// 删除运费模板
export function delShippingTemplate(data) {
  return request({
    url: '/shipping/template/delete',
    method: 'post',
    data: data
  })
}
